import React, { memo } from 'react';

import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { Col, Typography } from 'antd';

import { LandingLayout } from '@/containers/layout';

import content from './PrivacyPolicy.content';

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  return (
    <LandingLayout>
      <Col>
        <Typography.Title level={1}>{t('common.privacy-policy.title')}</Typography.Title>
      </Col>
      <Col>
        <div dangerouslySetInnerHTML={{ __html: content?.[i18next.language] }} />
      </Col>
    </LandingLayout>
  );
};

export default memo(PrivacyPolicy);
